



















































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { Utilities as utils } from "@/shared/utilities";
import "@/styles/iucn/timeline.css";
import RowItem from "./TimelineComponents/RowItem.vue";
import { Workspace } from "@/entities";
const namespace: string = "application";

@Component({
  components: {
    RowItem
  }
})
export default class ProjectTimelineComponent extends Vue {
  @Prop() appData!: any;
  @Prop() readOnly: boolean;
  @Getter("projectYrs", { namespace: "application" }) years: any;
  @Getter("reportingFrequency", { namespace: "application" }) reportingFreq: any;
  @State(namespace) application!: Workspace;
  logKey: number = 0;
  
  get timeFrame() {
    return this.reportingFreq;
  }

  // get timelineModel() {
  //   const self = this;
  //   if (!this.appData.timeline || Object.keys(this.appData.timeline).length === 0) {
  //     let timeline = {};
  //     this.appData.logframework.map((result, i) => {
  //       timeline[result.id] = {};
  //       result.deliverables.map((del, j) => {
  //         timeline[result.id][del.id] = {};
  //         del.activities.map((act, k) => {
  //           timeline[result.id][del.id][act.id] = {};
  //           self.years.map((yr) => {
  //             timeline[result.id][del.id][act.id][yr] = {};
  //             for( let t=1; t <= self.timeFrame; t++) {
  //               timeline[result.id][del.id][act.id][yr][t] = false;
  //             }
  //           });
  //         });
  //       });
  //     });
  //     this.appData.timeline = timeline;
  //   } else {
  //     Object.keys(this.appData.timeline).map(a => {
  //       const del = this.appData.timeline[a];
  //       if (del) {
  //         Object.keys(del).map(b => {
  //           const act = del[b];
  //           if(act) {
  //             Object.keys(act).map(c => {
  //               self.years.map((yr) => {
  //                 if (!act[c][yr]) { // if date is advanced
  //                   act[c][yr] = {};
  //                   for( let t=1; t <= self.timeFrame; t++) {
  //                     act[c][yr][t] = false;
  //                   }
  //                 }
  //               });
  //             });
  //           }
  //         });
  //       }
  //     });
  //   }
  //   return this.appData.timeline;
  // }

  section(frame: any) {
    if (this.timeFrame === 2) {
      switch (frame) {
        case 1:
          return this.$t('1st Half');
          break;
        case 2:
          return this.$t('2nd Half');
          break;
      }
    } else if (this.timeFrame === 4) {
      switch (frame) {
        case 1:
          return `${this.$t('Q')}1`;
          break;
        case 2:
          return `${this.$t('Q')}2`;
          break;
        case 3:
          return `${this.$t('Q')}3`;
          break;
        case 4:
          return `${this.$t('Q')}4`;
          break;
      }
    }
  }
}
